export default __webpack_public_path__ + "static/zen-advisor-endorsement-bg-7671ea443ba043f57ee98dc8088c22eb.jpg";